import { render, staticRenderFns } from "./ColorTheme.vue?vue&type=template&id=726b125c&"
import script from "./ColorTheme.vue?vue&type=script&lang=js&"
export * from "./ColorTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports